import React from 'react';

import { CloudServerOutlined } from '@ant-design/icons';

import { MLflowIcon, S3Icon } from '@/shared/assets/icons';
import { IcebergIcon, KafkaIcon, MongoDBIcon, PostgresIcon } from '@/shared/assets/images';

import styles from './ServiceIcon.module.css';

export type ServiceType = 'postgres' | 'kafka' | 'iceberg' | 's3' | 'mlflow' | 'mongodb' | 'redshift' | 'ceph-s3';

type ServiceIconProps = {
  serviceType?: string;
  size?: number;
  className?: string;
};

const SERVICE_KEY_PATTERNS: Array<[string[], string]> = [
  [['postgres', 'redshift'], 'postgres'],
  [['kafka'], 'kafka'],
  [['iceberg'], 'iceberg'],
  [['s3', 'ceph'], 's3'],
  [['mlflow'], 'mlflow'],
  [['mongodb', 'mongo'], 'mongodb'],
] as const;

const getServiceKey = (type: string): string => {
  const match = SERVICE_KEY_PATTERNS.find(([patterns]) => patterns.some((pattern) => type.includes(pattern)));

  return match?.[1] || type;
};

/**
 * 서비스 타입에 따른 아이콘을 렌더링하는 컴포넌트
 *
 * @param serviceType - 서비스 타입 (소문자로 정규화됨)
 * @param size - 아이콘 크기 (기본값: 20px)
 * @param className - 추가 CSS 클래스
 */
export const ServiceIcon: React.FC<ServiceIconProps> = ({ serviceType = '', size = 20, className }) => {
  const normalizedType = serviceType.toLowerCase().replace(/\s+/g, '-');
  const serviceKey = getServiceKey(normalizedType);

  const iconStyle = {
    width: `${size}px`,
    height: `${size}px`,
  };

  const combinedClassName = `${styles.serviceIcon} ${className || ''}`.trim();

  switch (serviceKey) {
    case 'postgres':
      return <img src={PostgresIcon} alt="Postgres" className={combinedClassName} style={iconStyle} />;
    case 'kafka':
      return <img src={KafkaIcon} alt="Kafka" className={combinedClassName} style={iconStyle} />;
    case 'iceberg':
      return <img src={IcebergIcon} alt="Iceberg" className={combinedClassName} style={iconStyle} />;
    case 'mongodb':
      return <img src={MongoDBIcon} alt="MongoDB" className={combinedClassName} style={iconStyle} />;
    case 's3':
      return <S3Icon className={combinedClassName} style={iconStyle} />;
    case 'mlflow':
      return <MLflowIcon className={combinedClassName} style={iconStyle} />;
    default:
      return (
        <CloudServerOutlined
          className={combinedClassName}
          style={{ fontSize: size, color: 'var(--opds-glo-palette-gray-30)' }}
        />
      );
  }
};
